import classNames from 'classnames'
import React from 'react'

const Icon: React.FunctionComponent<Iconprops> = ({
                                                     height,
                                                     width,
                                                     viewBox,
                                                     className,
                                                     children,
                                                     ...otherProps
                                                   }: Iconprops) => {
  const classes = classNames('Icon', className)
  return (
    <svg
      role="img"
      height={height}
      width={width}
      viewBox={viewBox}
      className={classes}
      {...otherProps}
    >
      {children}
    </svg>
  )
}

Icon.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 20 20',
}

type Iconprops = {
  width?: number,
  height?: number,
  viewBox?: string,
  className?: string,
  children?: React.ReactNode,
}

export default Icon
